export const SETTINGS_MODAL = 'SETTINGS_MODAL';
export const SETTINGS_TAB_TOGGLE = 'SETTINGS_TAB_TOGGLE';
export const PROFILE_TAB = 'PROFILE_TAB';
export const INTEGRATIONS_TAB = 'INTEGRATIONS_TAB';
export const AV_TAB = 'AV_TAB';
export const NETWORK_TAB = 'NETWORK_TAB';
export const EDIT_PROFILE_NAME = 'EDIT_PROFILE_NAME';
export const SETTINGS_AUDIO_MUTED = 'SETTINGS_AUDIO_MUTED';
export const SETTINGS_VIDEO_MUTED = 'SETTINGS_VIDEO_MUTED';
